type EnvironmentVariables = Record<string, string | undefined>
type RuntimeConfig = {
  API_BASE_URL?: string
}

const DEFAULT_API_BASE_URL = '/'
const DEFAULT_DEV_SERVER_PORT = 3000
const DEFAULT_API_PROXY_TARGET = 'http://localhost:4000'

function getDevServerPort(value: string | undefined): number {
  const port = Number.parseInt(value ?? '', 10)

  return Number.isNaN(port) ? DEFAULT_DEV_SERVER_PORT : port
}

function getRuntimeConfig(): RuntimeConfig | undefined {
  if (typeof window === 'undefined') {
    return undefined
  }

  return (window as Window & { __APP_CONFIG__?: RuntimeConfig }).__APP_CONFIG__
}

const runtimeConfig = getRuntimeConfig()

export const env = {
  API_BASE_URL:
    runtimeConfig?.API_BASE_URL ||
    import.meta.env?.VITE_API_BASE_URL ||
    DEFAULT_API_BASE_URL,
  NODE_ENV: import.meta.env?.MODE,
  IS_DEV: import.meta.env?.DEV,
  IS_PROD: import.meta.env?.PROD,
} as const

export function getDevServerEnv(variables: EnvironmentVariables) {
  return {
    PORT: getDevServerPort(variables.PORT),
    API_PROXY_TARGET: variables.API_PROXY_TARGET || DEFAULT_API_PROXY_TARGET,
  } as const
}

export type Env = typeof env
